"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./Field.css");
var Stack_1 = require("../../components/Stack");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var R = __importStar(require("../../utils/ramda"));
var Popover_1 = require("../../components/Popover");
var MDIcon_1 = require("../../components/MDIcon");
var Field = function (_a) {
  var help = _a.help,
    secondaryHelp = _a.secondaryHelp,
    error = _a.error,
    children = _a.children,
    className = _a.className,
    label = _a.label,
    labelFor = _a.labelFor,
    labelTooltip = _a.labelTooltip,
    labelTooltipProps = _a.tooltipProps,
    required = _a.required,
    optional = _a.optional,
    optionalLabel = _a.optionalLabel,
    tooltipIcon = _a.tooltipIcon,
    _b = _a.unsetFontSize,
    unsetFontSize = _b === void 0 ? false : _b,
    normalWeight = _a.normalWeight,
    restProps = __rest(_a, ["help", "secondaryHelp", "error", "children", "className", "label", "labelFor", "labelTooltip", "tooltipProps", "required", "optional", "optionalLabel", "tooltipIcon", "unsetFontSize", "normalWeight"]);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    gap: "medium",
    component: "fieldset",
    className: (0, classnames_1.default)("vsx-field", className, unsetFontSize && "vsx-field-unset-font-size")
  }, restProps, {
    children: [(0, jsx_runtime_1.jsx)(FieldLabel, {
      label: label,
      labelFor: labelFor,
      labelTooltip: labelTooltip,
      tooltipProps: labelTooltipProps,
      required: required,
      optional: optional,
      optionalLabel: optionalLabel,
      tooltipIcon: tooltipIcon,
      normalWeight: normalWeight
    }), children, (0, jsx_runtime_1.jsx)(FieldInfoRow, {
      help: help,
      secondaryHelp: secondaryHelp,
      error: error
    })]
  }));
};
exports.Field = Field;
var FieldLabel = function (_a) {
  var _b;
  var label = _a.label,
    labelFor = _a.labelFor,
    labelTooltip = _a.labelTooltip,
    labelTooltipProps = _a.tooltipProps,
    required = _a.required,
    optional = _a.optional,
    _c = _a.optionalLabel,
    optionalLabel = _c === void 0 ? "Optional" : _c,
    _d = _a.tooltipIcon,
    tooltipIcon = _d === void 0 ? false : _d,
    _e = _a.normalWeight,
    normalWeight = _e === void 0 ? false : _e;
  if (!label) {
    return null;
  }
  var cn = (0, classnames_1.default)("vsx-field-label", normalWeight && "vsx-field-label-normal-weight");
  var labelProps = labelTooltip && !tooltipIcon ? {
    style: {
      cursor: "pointer",
      borderBottom: "1px dashed var(--color-text-subdued)"
    }
  } : undefined;
  var content = (0, jsx_runtime_1.jsx)("label", __assign({
    className: cn,
    htmlFor: labelFor
  }, labelProps, {
    children: label
  }));
  var wrapperStyle = {
    flexDirection: "row"
  };
  var wrapperProps = R.mergeDeepRight({
    style: wrapperStyle
  }, (_b = labelTooltipProps === null || labelTooltipProps === void 0 ? void 0 : labelTooltipProps.wrapperProps) !== null && _b !== void 0 ? _b : {});
  var labelContent = (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
    content: labelTooltip,
    placement: "top",
    interactive: false,
    tooltip: true
  }, labelTooltipProps, {
    wrapperProps: wrapperProps,
    disabled: !labelTooltip || tooltipIcon,
    hideOnClick: false
  }, {
    children: content
  }));
  var iconContent = (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
    content: labelTooltip,
    placement: "top-start",
    interactive: false,
    tooltip: true
  }, labelTooltipProps, {
    wrapperProps: wrapperProps,
    disabled: !labelTooltip || !tooltipIcon,
    hideOnClick: false,
    arrow: false
  }, {
    children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      cursor: "pointer",
      color: "var(--color-icon-default)",
      icon: "information-outline",
      style: {
        transform: "scale(1.1) translateX(0.05em)"
      }
    })
  }));
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    gap: "medium-small",
    wrap: "nowrap"
  }, {
    children: [labelContent, required && (0, jsx_runtime_1.jsx)("span", __assign({
      className: "vsx-field-required-sign"
    }, {
      children: "*"
    })), optional && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [(0, jsx_runtime_1.jsx)("span", __assign({
        className: "vsx-field-optional-label"
      }, {
        children: "-"
      })), (0, jsx_runtime_1.jsx)("span", __assign({
        className: "vsx-field-optional-label"
      }, {
        children: optionalLabel
      }))]
    }), tooltipIcon && labelTooltip && iconContent]
  }));
};
var FieldInfoRow = function (_a) {
  var help = _a.help,
    secondaryHelp = _a.secondaryHelp,
    error = _a.error;
  if (!help && !secondaryHelp && !error) {
    return null;
  }
  var leftSect = function () {
    if (error) return (0, jsx_runtime_1.jsx)("span", __assign({
      className: "vsx-field-info-error"
    }, {
      children: error
    }));
    if (help) return (0, jsx_runtime_1.jsx)("span", __assign({
      className: "vsx-field-info-help"
    }, {
      children: help
    }));
    return (0, jsx_runtime_1.jsx)("span", {});
  };
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    justify: "space-between",
    gap: "medium",
    className: "vsx-field-info-row"
  }, {
    children: [leftSect(), secondaryHelp && (0, jsx_runtime_1.jsx)("span", __assign({
      className: "vsx-field-info-help"
    }, {
      children: secondaryHelp
    }))]
  }));
};